<div class="box_s" *ngIf="type == 'product'">

  
  <ul *ngIf="!db.ismobile" class="container__1 d__flex">
    <li class="sec_" *ngFor="let head of offers_title" [style.flex]="'0 0 calc('+ head.flex +')'">{{head.name}}</li>
  </ul>

  <ul class="list_box" [ngStyle]="{'height':'calc(100vh - 200px)'}" *ngIf="!db.ismobile && array_values && array_values.length != 0" (scroll)="!this.no_products ? loadData($event) : null">
    <li  class="d__flex box_" [ngStyle]="{'background-color': item.seen == 0 ? 'var(--hover-color)' : null }"
      *ngFor="let item of array_values">
      <div  [style.flex]="'0 0 calc('+ offers_title[0].flex +')'"
        class="d__flex mouse image_w_con">
        <div class="d__flex image-card-h"><img [src]="db.product_img(item.product_image)"><img *ngIf="item.seen == 0" src="assets/icon/profile_circle.svg" class="not_Read"></div>
    
        <div class="content">
          <h6 class="m-0 bold_name-14 web webkit-text" [style.--line]="1">{{item.item | titlecase}}</h6>
          <p *ngIf="item.content" class="m-0 d__flex small_name last_msg">
            <!-- <span class="sender_">{{item.user_email == db.cust_email ? 'You:' : ((item.recruiter_name.split(' ') ? item.recruiter_name.split(' ').pop() : item.recruiter_name) + ':') }} </span> -->
            <!-- <span class="m-0 msg_ webkit-text" [style.--line]="1" [innerHtml]="db.getInnerHTML(item.content)"></span> -->
          </p>
        </div>

      </div>


      <h6 [style.flex]="'0 0 calc('+ offers_title[1].flex +')'"
      class="m-0 mouse bold_name-14 web inner_html webkit-text" [style.--line]="1" [innerHTML]="item.attribute_description ? item.attribute_description : ''" ></h6>

      <h6  [style.flex]="'0 0 calc('+ offers_title[2].flex +')'"
      class="m-0 mouse bold_name-14 web webkit-text" [style.--line]="1">{{item.name}}</h6>

      <h6 [style.flex]="'0 0 calc('+ offers_title[3].flex +')'"
      class="m-0 mouse bold_name-14 web webkit-text" [style.--line]="1">{{item.sku ? item.sku : '-'}}</h6>

      <h6 [style.flex]="'0 0 calc('+ offers_title[4].flex +')'"
      class="m-0 mouse bold_name-14 web webkit-text open_sans__font" [style.--line]="1">{{item.price | currency: db.currency }}</h6>

      <ion-button (click)="list_click.emit(item)" *ngIf="item.is_template == 1" [style.flex]="'0 0 calc('+ offers_title[5].flex +')'" fill="clear" class="secondary-btn">Edit</ion-button>
     
    </li>

    <!-- <ion-infinite-scroll *ngIf="!no_products" threshold="800px" (ionInfinite)="loadData($event)">
      <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText=""></ion-infinite-scroll-content>
   </ion-infinite-scroll> -->

  </ul>


    <!-- Opportunity Mobile View Only -->
  <div (scroll)="!this.no_products ? loadData($event) : null" class="container" *ngIf="db.ismobile && array_values && array_values.length != 0">
    <div (click)="list_click.emit(item)" *ngFor="let item of array_values" class="mb_container">
       <div  class="b-1 d__flex">

        <div class="box_1 d__flex">
          <div class="d__flex image-card-h"><img [src]="db.product_img(item.product_image)"></div>
  
          <div class="content">
            <h6 class="m-0  bold_name web webkit-text" [style.--line]="1">{{item.item | titlecase}}</h6>
            <h6 class="m-0  mouse medium_name web webkit-text" [style.--line]="1"><span class="medium_name gray_cr">SKU : </span>{{item.sku ? item.sku : '-'}}</h6>
            <h6 class="m-0 mouse medium_name web webkit-text" [style.--line]="1"><span class="medium_name gray_cr open_sans__font">Price : </span>{{item.price | currency: db.currency }}</h6>
            <div *ngIf="item.attribute_description" class="d__flex">
              <span class="medium_name gray_cr">Variants : </span>
              <h6 class="m-0 mouse medium_name inner_html web webkit-text" [style.--line]="1" [innerHTML]="item.attribute_description"></h6>
            </div> 
          </div>
        </div>

       </div>

    </div>


  </div>

  <!-- Web Site Opportunity Loader -->

  <ul *ngIf="!db.ismobile && !array_values" class="list_box" [ngStyle]="{'height':'calc(100vh - 200px)'}" >
    <li class="d__flex box_" *ngFor="let item of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]">
      <div [style.flex]="'0 0 calc('+ offers_title[0].flex +')'"class="d__flex mouse image_w_con">
        <div class="d__flex image-card-h">
          <ion-skeleton-text style="border-radius: 50%;height: 30px;width: 30px;" [animated]="true"></ion-skeleton-text>
        </div>
        <div class="content">
          <ion-skeleton-text style="border-radius:2px;height: 20px;width: 60%;" [animated]="true"></ion-skeleton-text>
          <ion-skeleton-text style="border-radius:2px;height: 15px;width: 80%;" [animated]="true"></ion-skeleton-text>
        </div>

      </div>

      <h6 [style.flex]="'0 0 calc('+ offers_title[1].flex +')'"class="m-0 mouse bold_name-14 web webkit-text" [style.--line]="1">
        <ion-skeleton-text style="border-radius:2px;height: 15px;width: 60%;" [animated]="true"></ion-skeleton-text>
      </h6>

      <h6 [style.flex]="'0 0 calc('+ offers_title[2].flex +')'"class="m-0 mouse bold_name-14 web webkit-text" [style.--line]="1">
        <ion-skeleton-text style="border-radius:2px;height: 15px;width: 60%;" [animated]="true"></ion-skeleton-text>
      </h6>

      <h6 [style.flex]="'0 0 calc('+ offers_title[3].flex +')'"class="m-0 mouse bold_name-14 web webkit-text" [style.--line]="1">
        <ion-skeleton-text style="border-radius:2px;height: 15px;width: 60%;" [animated]="true"></ion-skeleton-text>
      </h6>

      <h6 [style.flex]="'0 0 calc('+ offers_title[4].flex +')'"class="m-0 mouse bold_name-14 web webkit-text" [style.--line]="1">
        <ion-skeleton-text style="border-radius:2px;height: 15px;width: 60%;" [animated]="true"></ion-skeleton-text>
      </h6>


    </li>


  </ul>

  <!-- Mobile Opportunity Loader -->

  <div *ngIf="db.ismobile && !array_values"  class="container">
    <div  *ngFor="let item of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]" class="mb_container">
       <div  class="b-1 d__flex">

        <div class="box_1 d__flex">
          
          <div class="d__flex image-card-h">
            <ion-skeleton-text style="border-radius: 5px;height: 60px;width: 60px;" [animated]="true"></ion-skeleton-text>
          </div>
          
          <div class="content d__flex ">
            <ion-skeleton-text style="border-radius: 5px;height: 20px;width: 60%;" [animated]="true"></ion-skeleton-text>
            <ion-skeleton-text style="border-radius: 5px;height: 15px;width: 80%;" [animated]="true"></ion-skeleton-text>
            <ion-skeleton-text style="border-radius: 5px;height: 15px;width: 40%;" [animated]="true"></ion-skeleton-text>
            <!-- <ion-skeleton-text style="border-radius: 5px;height: 15px;width: 60%;" [animated]="true"></ion-skeleton-text> -->
          </div>
          
        </div>
       </div>
    </div>
  </div>

  <app-no-record-found *ngIf="array_values && array_values.length == 0" height="calc(100vh - 200px)" heading="There’s no product found" [image]="'assets/no-product-POS.svg'"></app-no-record-found>

</div>
